<template>
  <div class="addOrUpdataProduct">
    <div class="title">
      <span>产品中心</span>
      <span>></span>
      <span>{{ this.productId ? '修改产品' : '添加产品' }}</span>
      <el-button class="returnPre" @click="backProductCenter">返回</el-button>
    </div>

    <div class="bt">
      <span>*</span>
      为必填项
    </div>
    <el-form ref="form" class="form" label-width="96px" :model="form" :rules="rules">
      <el-form-item label="产品名称：" prop="pName">
        <el-input v-model="form.pName" placeholder="请填写产品名称"></el-input>
      </el-form-item>

      <el-form-item label="产品类型：" prop="cProduct">
        <el-select
          v-model="form.cProduct"
          class="yggm_type"
          placeholder="请选择类型"
          @change="cProductSelect"
        >
          <el-option
            v-for="item in cProductOptions"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span style="color: red;margin-right: 5px;">*</span>
        <el-select
          v-model="form.cProduct_child"
          class="yggm_ly"
          placeholder="请选择所属领域"
          @change="cProductChildSelect"
        >
          <el-option
            v-for="item in cProduct_childOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <!-- <div style="display: inline-block" @click="clickCheckbox">
              <el-checkbox style="margin-right:11px;" v-model="item.isCheck"></el-checkbox>
            </div>
            <span>{{ item.label }}</span>-->
          </el-option>
          <!-- <div style="height: 45px;background-color: #fafafa;margin-bottom: 6px;">
            <el-checkbox @change="handleChecbox" style="margin-left: 20px;">其他</el-checkbox>
            <el-input
              :disabled="checkSelect_qita"
              v-model="checkSelect_qita_input"
              class="select_qita"
              style="width:320px;height:30px;"
            ></el-input>
          </div>-->
        </el-select>
      </el-form-item>

      <el-form-item label="产品配图：" class="adverposi" prop="cLogo">
        <el-upload
          class="avatar-uploader"
          :action="uploadAction"
          :show-file-list="false"
          :on-success="cLogoHandleAvatarSuccess"
          :before-upload="cLogoBeforeAvatarUpload"
        >
          <img v-if="logoImageUrl" :src="logoImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip rihtDpi">配图显示到产品封面，上传图片不要超过2M</div>
          <img
            :src="require('../../../assets/image/delete_icon.png')"
            alt
            class="delete__icon"
            @click="deleteImg"
          />
          <div class="adverpt">上传图片</div>
        </el-upload>
      </el-form-item>

      <el-form-item label="产品描述:" prop="introduction">
        <div id="editor"></div>
      </el-form-item>
    </el-form>
    <div class="preservation">
      <el-button @click="preservationBtn">保存</el-button>
    </div>
  </div>
</template>
<script>
import E from "wangeditor";
export default {
  props: ["productId", "staticPro"],
  components: {},
  data() {
    return {
      editor: "",
      form: {
        cProduct: "",
        cProduct_child: "",
        pName: "",
        introduction: "",
        cLogo: "",
        childTypeId: "", // 二级产品类型id
        parentTypeId: "", // 一级产品类型id
      },
      productList: [],
      cProductOptions: [],
      cProduct_childOptions: [],

      // 产品类型多选下拉input
      checkSelect_qita_input: "",
      checkSelect_qita: true,
      // 图片上传路径
      uploadAction: this.$http.adornUrl(`/fileupload/upload`),
      logoImageUrl: "",
      rules: {
        cProduct: [{ required: true, message: "*为必填项", trigger: "change" }],
        cLogo: [{ required: true, message: "*为必填项", trigger: "blur" }],
        pName: [{ required: true, message: "*为必填项", trigger: "blur" }],
        introduction: [
          { required: true, message: "*为必填项", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getProduct();
  },
  mounted() {
    this.initEditor();
    this.$nextTick(() => {
      this.$refs.form.clearValidate();
      if (this.productId) {
        this.productInfoObj();
      }
    });
  },
  methods: {
    initEditor() {
      this.editor = new E("#editor");
      // 隐藏网络图片，上传本地
      this.editor.customConfig.showLinkImg = false;
      this.editor.customConfig.uploadFileName = "file";
      this.editor.customConfig.uploadImgServer = this.uploadAction;
      let that = this;
      this.editor.customConfig.uploadImgHooks = {
        customInsert: function (insertImg, result, editor) {
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          if (result.code === 0) {
            insertImg(that.$http.adornUrl(result.data.url));
          } else {
            flavrShowByTime("上传失败", null, "danger");
          }
        },
      };
      this.editor.customConfig.uploadVideoServer = this.$http.adornUrl(
        `/fileupload/uploadVideo?token=${this.$cookie.get("token")}`
      );
      this.editor.customConfig.uploadVideoHooks = {
        customInsert: function (insertVideo, result, editor) {
          // insertVideo 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          if (result.code === 0) {
            insertVideo("http://10.165.5.36/" + result.data.url);
          } else {
            flavrShowByTime("上传失败", null, "danger");
          }
        },
        success: function success(xhr, editor, result) {
          // 视频上传并返回结果，视频插入成功之后触发
        },
      };

      this.editor.customConfig.onchange = (html) => {
        this.form.introduction = html;
      };
      this.editor.create();
      // this.editor.txt.html();
    },

    // 获取产品类型
    getProduct() {
      this.$http({
        url: "getProductList",
        method: "post",
      }).then((data) => {
        let { code, proParentList } = data.data;
        if (code === 0) {
          this.productList = proParentList;
          let arr = [];
          proParentList.forEach((res, index) => {
            arr[index] = {
              label: res.name,
              value: res.id,
            };
          });
          this.cProductOptions = arr;
        }
      });
    },

    // 产品详情
    productInfoObj() {
      this.$http({
        url: "getAccConInfoById",
        method: "post",
        params: {
          accConId: this.productId,
        },
      })
        .then(({ data }) => {
          let { code, accContentEntity } = data;
          if (code === 0) {
            let sParent = accContentEntity.jsonProduct.parent;
            let sChild = accContentEntity.jsonProduct.subset;
            this.cProductSelect(sParent === 0 ? sChild : sParent);
            this.cProductChildSelect(sParent === 0 ? "" : sChild);
            this.form.pName = accContentEntity.title;
            this.logoImageUrl = this.$getSrc(accContentEntity.image);
            this.form.introduction = accContentEntity.content;
            this.editor.txt.html(accContentEntity.content);
            this.form.cLogo = accContentEntity.image;
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch((err) => this.$message.error(data.msg));
    },

    // 防止CheckBox向上emit(二级产品类型会触发一级的change事件)
    clickCheckbox(e) {
      e.preventDefault();
    },
    // 产品类型一级select
    cProductSelect(val) {
      // this.form.parentTypeId = val;
      this.form.cProduct = val;
      let pLen = this.productList.length;
      let childrenSelect = [];
      if (pLen > 0) {
        let a = this.productList.filter((res) => {
          return res.id === val;
        });
        childrenSelect = a;
      } else {
        let b = this.staticPro.filter((res) => {
          return res.id === val;
        });
        childrenSelect = b;
      }
      let arr = [];
      if (childrenSelect[0]) {
        childrenSelect[0].children.forEach((el, index) => {
          arr[index] = {
            label: el.name,
            value: el.id,
            isCheck: false,
          };
        });
      }
      this.cProduct_childOptions = arr;
    },
    // 产品类型二级select  val是下拉框选择多选时的list
    cProductChildSelect(val) {
      this.form.cProduct_child = val;
      // this.cProduct_childOptions.forEach(res => {
      //   res.isCheck = false;
      // });
      // val.forEach(res => {
      //   this.cProduct_childOptions.forEach(el => {
      //     if (res === el.value) {
      //       el.isCheck = true;
      //     }
      //   });
      // });
    },
    // 产品类型的其他
    handleChecbox(val) {
      if (val) {
        this.checkSelect_qita = false;
      } else {
        this.checkSelect_qita = true;
      }
    },
    // logo上传成功
    cLogoHandleAvatarSuccess(res, file) {
      this.logoImageUrl = URL.createObjectURL(file.raw);
      this.form.cLogo = res.data.url;
    },
    // logo上传之前
    cLogoBeforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    },
    deleteImg(e) {
      e.stopPropagation(); // 删除的时候不让触发添加图片的方法
      this.logoImageUrl = "";
    },

    // 保存
    preservationBtn() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$http
            .post(`${this.productId ? "updateAccCon" : "saveAccCon"}`, {
              id: this.productId || "",
              type: "0",
              title: this.form.pName,
              content: this.form.introduction,
              image: this.form.cLogo,
              productId: this.form.cProduct_child
                ? this.form.cProduct_child
                : this.form.cProduct,
            })
            .then(({ data }) => {
              let { code, msg } = data;
              if (code === 0) {
                this.$message({
                  message: `产品${this.productId ? "修改" : "添加"}成功！`,
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$emit("addUpdateStatus");
                    this.$emit("getProductList", "5");
                  },
                });
              } else {
                this.$message.error(msg);
              }
            })
            .catch((err) => console.log(err));
        }
      });
    },
    backProductCenter() {
      this.$emit("addUpdateStatus");
      this.$emit("productIdSetNull");
    },
  },
};
</script>
<style lang="scss">
.addOrUpdataProduct {
  .el-input__inner {
    height: 42px;
  }
  .quillWrapper {
    width: 624px;
    height: 385px;
    .ql-container {
      height: 74%;
    }
  }
  .avatar-uploader-icon {
    background-color: #e5e5ee;
  }
  .avatar-uploader .el-upload {
    position: static;
  }
  .el-icon-plus:before {
    content: "" !important;
  }
}
</style>
<style lang="scss" scoped>
.addOrUpdataProduct {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 25px;
    span:first-child {
      cursor: pointer;
    }
    span:nth-child(2) {
      margin: 0 8px;
    }
  }
  .bt {
    width: 66px;
    height: 14px;
    line-height: 14px;
    float: right;
    color: #999999;
    margin-right: 30px;
    font-size: 14px;
    span {
      color: #ff6059;
    }
  }
  .rihtDpi {
    float: right;
    margin: 125px 230px 0 0;
    color: #999999;
  }
  .form {
    margin-top: 60px;
    padding: 0 116px 0 84px;
    .yggm_type {
      width: 238px;
      margin-right: 46px;
    }
    .yggm_ly {
      width: 320px;
    }
    .el-input {
      width: 624px;
    }
  }
  .preservation {
    margin: 180px 0 43px 0;
    text-align: center;
    button {
      width: 160px;
      height: 50px;
      font-size: 18px;
      color: #ffffff;
      background-color: #143372;
    }
  }
  .adverposi {
    position: relative;
  }
  .adverpt {
    width: 150px;
    height: 38px;
    background-color: #727272;
    position: absolute;
    bottom: 2px;
    left: 0;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    line-height: 38px;
  }
  .delete__icon {
    position: absolute;
    right: 481px;
    top: 6px;
    cursor: pointer;
  }
}
</style>